import { useEffect } from "react";
import { PageControl, KIND } from "baseui/page-control";
import { useNavigate } from 'react-router-dom';
import { Analytics, Gtag } from '../../compornents/Analytics';
import React from 'react';

export const OrderStep3 = () => {
  const navigate = useNavigate();


  const next = () => {
    navigate('/order_step/step4');
  }

  useEffect(() => {
    Gtag('view_order_step3');
  }, []);

  return (
    <div>
      <div>
        <Analytics title="OrderStep3" />
        <div className="Register">
          <div className="App-step1">
            <div className="App-h1 pt-5">{"STEP.3"}</div>
            <img src="/img/step3-3.png" alt="step3" className="App-img" />
            <div className="App-title">クリーニング中</div>
            <div className="App-comment">クリーニングが仕上がるまで、いましばらくお待ちください</div>
            <div className="App-h3">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                }}
              >
                <PageControl
                  currentPage={4}
                  numPages={6}
                  kind={KIND.default}
                  aria-label="label"
                />
              </div>
              <button className="button-next-w" onClick={next}>{"次へ"}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
